if (!customElements.get('countdown-banner')) {
  class CountdownBanner extends HTMLElement {
    connectedCallback() {
      if (this.isReturningVisitor()) {
        this.hidden = true;
        return;
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.startTimer(), { once: true });
        return;
      }

      this.startTimer();
    }

    disconnectedCallback() {
      clearInterval(this.intervalId);
    }

    getBerlinDate() {
      return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin' }).format(new Date());
    }

    isReturningVisitor() {
      const today = this.getBerlinDate();

      try {
        const firstSeenDate = localStorage.getItem('countdown-banner-first-seen');

        if (!firstSeenDate) {
          localStorage.setItem('countdown-banner-first-seen', today);
          return false;
        }

        return firstSeenDate < today;
      } catch (error) {
        return false;
      }
    }

    getNextBerlinMidnight() {
      const formatter = new Intl.DateTimeFormat('de-DE', {
        timeZone: 'Europe/Berlin',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      const parts = formatter.formatToParts(new Date());
      const getPart = (type) => parts.find((part) => part.type === type)?.value;

      const berlinNow = new Date(
        `${getPart('year')}-${getPart('month')}-${getPart('day')}T${getPart('hour')}:${getPart('minute')}:${getPart('second')}`
      );

      const berlinMidnight = new Date(berlinNow);
      berlinMidnight.setHours(24, 0, 0, 0);

      return new Date(Date.now() + (berlinMidnight.getTime() - berlinNow.getTime()));
    }

    startTimer() {
      this.daysElement = this.querySelector('[data-countdown-days]');
      this.hoursElement = this.querySelector('[data-countdown-hours]');
      this.minutesElement = this.querySelector('[data-countdown-minutes]');
      this.secondsElement = this.querySelector('[data-countdown-seconds]');
      this.nextMidnight = this.getNextBerlinMidnight();

      this.updateCountdown();
      this.intervalId = setInterval(() => this.updateCountdown(), 1000);
    }

    updateCountdown() {
      const now = new Date();
      let timeRemaining = this.nextMidnight - now;

      if (timeRemaining <= 0) {
        this.nextMidnight = this.getNextBerlinMidnight();
        timeRemaining = this.nextMidnight - now;
      }

      const totalSeconds = Math.floor(timeRemaining / 1000);
      const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.daysElement.textContent = '00';
      this.hoursElement.textContent = hours.toString().padStart(2, '0');
      this.minutesElement.textContent = minutes.toString().padStart(2, '0');
      this.secondsElement.textContent = seconds.toString().padStart(2, '0');
    }
  }

  customElements.define('countdown-banner', CountdownBanner);
}
